/* TMC — live promo pricing (v2.0).
   window.tmcPromo = { base: 15, secret: 30, code: 'KONAMI', currency: 'USD' }

   SINGLE SOURCE OF TRUTH. All homepage sections now render TRUE prices
   (promo = 0 in the theme editor); this script applies the discount once,
   everywhere — homepage grids, rails, spotlight, quick-add buttons,
   collection pages, product pages, and "You may also like".

   Guard rails against double-discounting:
     • every node is stamped data-tmc-done once rendered
     • a node that already contains .tmc-was is never re-based
     • a Shopify compare-at strike is ignored as a base (that's a sale
       price, not our promo) — we always discount the real selling price
*/
(function(){
  var cfg=window.tmcPromo||{};
  var BASE=+cfg.base||0, SECRET=+cfg.secret||0, CODE=cfg.code||'', CUR=cfg.currency||'USD';
  if(!BASE&&!SECRET)return;

  var fmt;
  try{fmt=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:CUR})}
  catch(e){fmt={format:function(v){return '$'+v.toFixed(2)}}}
  function money(v){return fmt.format(v)}

  function parse(s){
    if(!s)return NaN;
    var m=(s+'').replace(/[^0-9.,]/g,'').trim();
    if(!m)return NaN;
    if(m.indexOf(',')>-1&&m.indexOf('.')>-1){m=m.replace(/,/g,'')}
    else if(m.indexOf(',')>-1&&/,\d{2}$/.test(m)){m=m.replace(',','.')}
    else{m=m.replace(/,/g,'')}
    var n=parseFloat(m);return isNaN(n)?NaN:n;
  }
  function rate(){return document.documentElement.classList.contains('hw-secret-on')?SECRET:BASE}

  /* every price surface on the site, including related products */
  var SEL=[
    '.price__container .price-item--regular',
    '.price__container .price-item--sale',
    '.card-information .price .price-item--regular',
    '.card-information .price .price-item--sale',
    '.related-products .price .price-item--regular',
    '.related-products .price .price-item--sale',
    'product-recommendations .price .price-item--regular',
    'product-recommendations .price .price-item--sale',
    '.complementary-products .price .price-item--regular',
    '.hw-price','.hw-feat-price','.tmc-qa'
  ].join(',');

  /* the true selling price this node represents */
  function baseOf(node){
    if(node.dataset.tmcBase)return +node.dataset.tmcBase;
    var txt=node.textContent||'';
    /* drop any struck figure — compare-at or a previous render */
    var strikes=node.querySelectorAll?node.querySelectorAll('s, .tmc-was, .hw-was'):[];
    for(var i=0;i<strikes.length;i++){txt=txt.split(strikes[i].textContent).join(' ')}
    var b=parse(txt);
    if(isNaN(b)||b<=0)return NaN;
    node.dataset.tmcBase=b;
    return b;
  }

  function render(node){
    if(node.dataset.tmcDone==='1'&&node.dataset.tmcRate===String(rate()))return;
    var b=baseOf(node);if(isNaN(b)||b<=0)return;
    var pct=rate();
    var now=Math.round(b*(100-pct))/100;

    if(node.classList.contains('tmc-qa')){
      var lbl=(node.textContent||'').split('\u2014')[0].trim()||'Quick Add';
      node.textContent=lbl+' \u2014 '+money(now);
      node.dataset.tmcDone='1';node.dataset.tmcRate=String(pct);
      return;
    }

    var val=node.querySelector('.tmc-now');
    var was=node.querySelector('.tmc-was');
    if(!val){
      node.innerHTML='';
      was=document.createElement('s');was.className='tmc-was';
      val=document.createElement('span');val.className='tmc-now';
      node.appendChild(was);node.appendChild(val);
    }
    if(!was){was=document.createElement('s');was.className='tmc-was';node.insertBefore(was,val)}
    was.textContent=money(b);
    val.textContent=money(now);
    was.style.display=pct>0?'':'none';
    node.dataset.tmcDone='1';node.dataset.tmcRate=String(pct);
  }

  function paintAll(){
    if(!rate())return;
    document.querySelectorAll(SEL).forEach(function(n){
      if(n.closest('.tmc-size'))return;
      try{render(n)}catch(e){}
    });
    note();chips();
  }

  function note(){
    var host=document.querySelector('.product__info-container .price')||document.querySelector('.product__info-container');
    if(!host)return;
    var pct=rate();
    var el=document.querySelector('.tmc-promo-note');
    if(!pct){if(el)el.remove();return}
    if(!el){el=document.createElement('div');el.className='tmc-promo-note';host.parentNode.insertBefore(el,host.nextSibling)}
    el.innerHTML='<span class="dot"></span><span><b>'+pct+'% off</b> \u2014 '+
      (pct===SECRET&&CODE?('applied with code <b>'+CODE+'</b> at checkout'):'applied automatically at checkout')+'</span>';
  }

  function chips(){
    var pct=rate();
    document.querySelectorAll('.hw-chip--sale').forEach(function(c){c.textContent='-'+pct+'%'});
  }

  /* variant change / section reload — clear the cache and repaint */
  function reset(){
    document.querySelectorAll('[data-tmc-base]').forEach(function(n){
      delete n.dataset.tmcBase;delete n.dataset.tmcDone;delete n.dataset.tmcRate;
    });
    paintAll();
  }

  function boot(){paintAll();setTimeout(paintAll,400);setTimeout(paintAll,1200)}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot)}else{boot()}
  document.addEventListener('shopify:section:load',function(){setTimeout(reset,80)});
  document.addEventListener('tmc:secret',function(){reset()});

  /* related products and recommendations load in async — catch them */
  var t=null;
  new MutationObserver(function(muts){
    for(var i=0;i<muts.length;i++){
      var m=muts[i];
      for(var j=0;j<m.addedNodes.length;j++){
        var n=m.addedNodes[j];
        if(n.nodeType===1&&(n.querySelector&&n.querySelector('.price')||n.classList&&n.classList.contains('price'))){
          clearTimeout(t);t=setTimeout(paintAll,80);return;
        }
      }
    }
  }).observe(document.documentElement,{childList:true,subtree:true});

  document.addEventListener('DOMContentLoaded',function(){
    var pi=document.querySelector('.product__info-container');
    if(pi)new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        var n=muts[i].target;
        if(n&&n.closest&&n.closest('.price')&&!n.closest('.tmc-now')&&!n.closest('.tmc-was')){
          clearTimeout(t);t=setTimeout(reset,60);break;
        }
      }
    }).observe(pi,{childList:true,subtree:true,characterData:true});
  });

  window.tmcPromoRepaint=reset;
})();
